import { ClickAwayListener } from "@mui/material";
import { useRef } from "react";
import { IconButton, OverflowTooltip, Tooltip } from "ui-components-library";
import { Wrapper, StyledPopper } from "../AppListV2/AppsListV2.styles";
import {
  UserDataWrapper,
  UserDataName,
  UserDataPosition,
  StyledAvatar,
  StyledAccountIcon,
  StyledPopperBox,
  PopperArrow,
  EmailText,
  StyledMenuItemBottom,
} from "./UserInfoV2.styles";
import { StyledDivider } from "../HeaderV2.styles";

interface UserInfoV2Props {
  userName: string | undefined;
  userEmail: string | undefined;
  userRoles: string | undefined;
  flexpertImg?: string | null;
  anchorEl: Element | null;
  openMenu: (event) => void;
  closeMenu: () => void;
  logout: (event) => void;
}

const UserInfoV2 = ({
  userName,
  userEmail,
  userRoles,
  flexpertImg = null,
  anchorEl,
  openMenu,
  closeMenu,
  logout,
}: UserInfoV2Props) => {
  const arrowRef = useRef<HTMLSpanElement | null>(null);
  const rolesArray = userRoles?.split(", ") ?? [];
  const visibleRoles = rolesArray.slice(0, 1).join(", ");
  const hiddenRoles = rolesArray.length > 1;

  return (
    <Wrapper>
      <UserDataWrapper>
        <UserDataName variant="body1">{userName}</UserDataName>
        <UserDataPosition>
          <OverflowTooltip style={{}}>
            <Tooltip tooltip={userRoles}>
              <span style={{ paddingBottom: "15px" }}>
                {hiddenRoles ? `${visibleRoles}...` : visibleRoles}
              </span>
            </Tooltip>
          </OverflowTooltip>
        </UserDataPosition>
      </UserDataWrapper>

      <IconButton onClick={openMenu}>
        {flexpertImg ? <StyledAvatar /> : <StyledAccountIcon />}
      </IconButton>

      <StyledPopper
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        placement="bottom-end"
        modifiers={[{ name: "offset", options: { offset: [0, 8] } }]}
      >
        <ClickAwayListener onClickAway={closeMenu}>
          <StyledPopperBox>
            <PopperArrow ref={arrowRef} />
            <EmailText>{userEmail}</EmailText>
            {/* <RoleText>{userRole}</RoleText>
            <CompanyName>CBRE, Inc</CompanyName> */}
            <StyledDivider />
            {/* {userRole === "Super Admin" && (
              <StyledMenuItemTop onClick={() => window.location.reload()}>
                User Managment
              </StyledMenuItemTop>
            )} */}
            <StyledMenuItemBottom onClick={logout}>
              Sign Out
            </StyledMenuItemBottom>
          </StyledPopperBox>
        </ClickAwayListener>
      </StyledPopper>
    </Wrapper>
  );
};

export default UserInfoV2;
